import HouseIcon from '@mui/icons-material/House';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import InputIcon from '@mui/icons-material/Input';

import React from 'react';

import { PoolBrainCustomerLocationDTO } from '_lib/api/apiTypes.shim';
import { Avatar } from '_lib/components/Avatar/Avatar';

import { IconButton } from '_lib/components/IconButton/IconButton';
import { List, ListProps } from '_lib/components/List/List';
import { ListItem } from '_lib/components/ListItem/ListItem';
import { ListItemAvatar } from '_lib/components/ListItemAvatar/ListItemAvatar';
import { ListItemText } from '_lib/components/ListItemText/ListItemText';
import { Stack } from '_lib/components/Stack/Stack';

import { Tooltip } from '_lib/components/Tooltip/Tooltip';

import { formatAddressOneLine } from '_lib/utils/helpers';

type CustomerLocationListProps = ListProps & {
  customerLocations: PoolBrainCustomerLocationDTO[];
  onSetCustomerLocation: (customerLocation: PoolBrainCustomerLocationDTO) => void;
};

export const CustomerLocationList = (props: CustomerLocationListProps) => {
  const { customerLocations, onSetCustomerLocation, ...listProps } = props;

  return (
    <List disablePadding {...listProps}>
      {customerLocations.map((customerLocation) => (
        <ListItem
          sx={{ paddingRight: 14 }}
          key={customerLocation.providerId}
          divider
          secondaryAction={
            <Stack direction='row'>
              <Tooltip title='Select Customer' placement='bottom'>
                <IconButton onClick={() => onSetCustomerLocation(customerLocation)}>
                  <HowToRegIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title={`${customerLocation.locationURL}`} placement='bottom'>
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    window.open(customerLocation.locationURL, '_blank', 'popup');
                  }}>
                  <InputIcon />
                </IconButton>
              </Tooltip>
            </Stack>
          }>
          <ListItemAvatar>
            <Avatar>
              <HouseIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={customerLocation.customer.name || 'UNKNOWN'}
            secondary={formatAddressOneLine(customerLocation)}
          />
        </ListItem>
      ))}
    </List>
  );
};
